<template>
    <div>
        <div
            class="template-header d-flex justify-content-between align-items-center"
        >
            <div class="text-group">
                <h1 class="break-word">{{ template.title }}</h1>
                <h5 class="break-word">{{ template.description }}</h5>
            </div>
            <div
                class="button-group d-flex justify-content-between align-items-center"
            >
                <!-- <b-form-checkbox switch size="sm" /> -->
                <b-button variant="light" @click="$emit('edit')">
                    <pencil color="#009BDB" />
                </b-button>
                <b-button variant="light" @click="$emit('delete')">
                    <trash color="#009BDB" />
                </b-button>
            </div>
        </div>
        <div class="template-asks">
            <div
                class="asks-list"
                v-for="ask in template.askings"
                :key="'ask-' + ask.id"
            >
                <Ask :ask="ask" @delete-ask="popAsk($event)" />
            </div>
            <NewAsk :templateId="template.id" @created="pushAsk($event)" />
        </div>
    </div>
</template>

<script>
import { Ask, NewAsk, Trash, Pencil } from './asks'

export default {
    name: 'Template',
    components: {
        Ask,
        NewAsk,
        Trash,
        Pencil,
    },
    props: {
        template: {
            type: Object,
            default() {
                return {
                    title: '',
                    description: '',
                    askings: [],
                }
            },
        },
    },
    methods: {
        popAsk(id) {
            const askings = this.template.askings.filter(item => item.id !== id)
            this.$emit('update', { ...this.template, askings })
        },
        pushAsk(ask) {
            let template = this.template

            if (template.askings === undefined) {
                template = {
                    ...template,
                    askings: [],
                }
            }
            template.askings.push(ask)
            this.$emit('update', template)
        },
    },
}
</script>

<style lang="sass" scoped>
$text-grey: #6f6f6f
.break-word
    overflow-wrap: break-word
    width: 100%
    display: inline-block

::v-deep
    .template-header
        margin-bottom: 10px
        .button-group
            flex-direction: row
            justify-content: center
            align-items: center
            margin-left: 10px
    .text-group
        color: $text-grey
        text-align: left
        max-width: 90%
        h1
            font-size: 24px
            font-weight: bold
            margin-bottom: 2px

        h5
            font-size: 13px

    .btn-light
        background-color: #ffffff
        border: 0
        &:focus
            outline: none
            border: none !important
            -webkit-box-shadow: none !important
            -moz-box-shadow: none !important
            box-shadow: none !important
</style>
